<template>
    <div class="message-dashboard-page">
        <div class="container">
            <!-- <section style="display:flex;justify-content:center;">
                <div class="scrollmenu" style="width:50%;background-color:black;">
                    <a v-for="(user, i) in users" :key="i" href="#" class="notification">
                        <span>{{user.name}}</span>
                        <span class="badge">{{user.notification}}</span>
                    </a>
                </div>
            </section> -->
            
            <section ref="chatArea" class="chat-area">
                <p v-for="(message, i) in messages" :key="i" class="message" :class="{ 'message-out': message.is_opponent === true, 'message-in': message.is_opponent !== true }">
                {{ message.text }}<br/>
                <small>{{message.created_at}}</small>
                </p>
            </section>
            
            <section class="chat-bottom">
                <div class="chat-bottom-content">
                    <form @submit.prevent="sendMessage()" id="person2-form">
                        <!-- <input v-model="youMessage" id="person2-input" class="form-control input-sm chat_input" type="text" placeholder="Write your message here...">
                        <button class="btn btn-primary chat_button" type="submit">Send</button> -->
                        <input v-model="youMessage" class="chat_input" id="person2-input" type="text" placeholder="Type your message">
                        <button class="chat_button" type="submit">Send</button>
                    </form>
                </div>
            </section>

            <!-- <section class="chat-inputs">

                <form @submit.prevent="sendMessage('in')" id="person1-form">
                <label for="person1-input">Bob</label>
                <input v-model="bobMessage" id="person1-input" type="text" placeholder="Type your message">
                <button type="submit">Send</button>
                </form>
            <button @click="clearAllMessages">Clear All</button>
                <form @submit.prevent="sendMessage('out')" id="person2-form">
                <label for="person2-input">You</label>
                <input v-model="youMessage" id="person2-input" type="text" placeholder="Type your message">
                <button type="submit">Send</button>
                </form>
            </section>
            <div style="width:50%;height:100px;background-color:red;">

            </div> -->
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            userChannel: this.$route.params.channel,
            bobMessage: '',
            youMessage: '',
            // messages: [
            //     {
            //         body: 'Welcome to the chat, I\'m Bob!',
            //         author: 'bob',
            //         time: '07.30 AM'
            //     },
            //     {
            //         body: 'Thank you Bob',
            //         author: 'you',
            //         time: '07.30 AM'
            //     },
            //     {
            //         body: 'You\'re most welcome',
            //         author: 'bob',
            //         time: '07.30 AM'
            //     }
            // ],
            users: [
                {
                    name: 'addrian',
                    notification: 2
                },
                {
                    name: 'stephen',
                    notification: 7
                },
                {
                    name: 'nick',
                    notification: 21
                },
                {
                    name: 'jimmy',
                    notification: 22
                },
                {
                    name: 'lawrence',
                    notification: 12
                },
                {
                    name: 'nick',
                    notification: 21
                },
                {
                    name: 'jimmy',
                    notification: 22
                },
                {
                    name: 'lawrence',
                    notification: 12
                },
            ],
        }
    } ,
    computed: mapState(["messages", "userMessages","accessToken"]),
    watch: {
        messages: function(updated, old) {
            var that = this;
            setTimeout(function(){ that.scrollToEnd(); }, 100)
            // this.scrollToEnd()
        },
        unreadMessages: function(updated, old) {
            var that = this;
            setTimeout(function(){ that.scrollToEnd(); }, 100)
            // this.scrollToEnd()
        },
    },
    async created() {
        if (this.userChannel) {
            await this.$store.dispatch("loadUserMessages", this.userChannel);
        } else {
            await this.$store.dispatch("loadMessages");
        }
    },
    methods: {
        async sendMessage() {
            var channel_id = this.$route.params.channel ? this.$route.params.channel : null
            let message_text = this.youMessage;
            this.youMessage = '';
            var sendingMessages = await this.$store.dispatch("writeMessages", {text: message_text, channel: channel_id});
            if (sendingMessages.status==201) {
                this.messages.push({text: message_text, is_opponent: false, created_at: ''})
                if (this.$store.getters.isAdmin){
                    this.$store.dispatch("loadUserMessages",this.userChannel);
                }else{
                    this.$store.dispatch("loadMessages");
                    }
            }
        },
        clearAllMessages() {
            this.messages = []
        },
        scrollToEnd: function() {    	
            var container = this.$el.querySelector(".chat-area");
            container.scrollTop = container.scrollHeight;
        },
    }
}
</script>

<style lang="css" scoped>
.message-dashboard-page {
    padding: 50px 0;
}
.chat-area {
  border: 1px solid #ccc;
  background: white;
  height: 50vh;
  padding: 1em;
  overflow: auto;
  min-width: 536px;
  max-width: 50%;
  margin: 0 auto 0 auto;
  scroll-behavior: smooth;
  /* box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.3) */
}
.message {
  width: 45%;
  border-radius: 10px;
  padding: .5em;
/*   margin-bottom: .5em; */
  font-size: .8em;
}
.message-out {
  background: #407FFF;
  color: white;
  margin-left: 55%;
}
.message-in {
  background: #F1F0F0;
  color: black;
}
.message-out  > small {
    /* margin-left: 79%; */
    font-size: 9px;
    color: #d4d1d1;
}
.message-in  > small {
    /* margin-left: 79%; */
    font-size: 9px;
    color: grey;
}
.chat-inputs {
  display: flex;
  justify-content: space-between;
}
.chat-bottom {
    display:flex;
    justify-content:center;
}
.chat-bottom-content {
    min-width: 536px;
    width: 50%;
    background-color:black;
}
/* .chat-input {
  display: flex;
  justify-content: center;
} */
.chat_input {
    width: 80%;
}
.chat_button {
    width: 20%;
    height:44px;
}
#person1-input {
  padding: .5em;
}
#person2-input {
  padding: .5em;  
}

/* user part scroll */
div.scrollmenu {
  background-color: #333;
  overflow: auto;
  white-space: nowrap;
}

/* div.scrollmenu a {
  display: inline-block;
  color: white;
  text-align: center;
  padding: 14px;
  text-decoration: none;
}

div.scrollmenu a:hover {
  background-color: #777;
} */

.notification {
  background-color: #555;
  color: white;
  text-decoration: none;
  padding: 15px 26px;
  position: relative;
  display: inline-block;
  border-radius: 2px;
}

.notification:hover {
  background: red;
}

.notification .badge {
  position: absolute;
  top: 0px;
  right: 0px;
  /* padding: 6px 8px; */
  border-radius: 0%;
  background-color: red;
  color: white;
}
@media screen and (max-width: 600px) {
    .chat-area {
        min-width: 270px;
        max-width: 100%;
    }
    .chat-bottom-content {
        min-width: 270px;
        width: 100%;
    }
}
</style>